export const POLICY_TYPE_NAME = { 'privacy': '개인정보처리방침', 'terms': '이용약관' };

export const CATEGORY_KDC_NAME_LIST = ['문학', '인문/예술', '사회과학', '자연과학'];
export const CATEGORY_GENERAL_NAME_LIST = ['읽기물', '그림책', '논픽션', '학습만화', '기타'];
export const CATEGORY_GENERAL2_NAME_LIST = ['창작', '인성.성장', '수학경제', '과학', '위인.인물', '역사', '사회문화', '철학', '예체능', '자연관찰', '지식정보', '전래', '명작', '고전', '성교육', '직업', '추리', '환경', '동시'];


export const GRADE_NAME_LIST = ['예비초', '1학년', '2학년', '3학년', '4학년', '5학년', '6학년', '중학생'];
export const BOOK_GENDER_LIST = { 'ALL': '무관', 'MALE': '남자', 'FEMALE': '여자' };
export const READING_TYPE_LIST = { 'report': '독서감상문', 'quiz': '퀴즈', 'picture': '독서화', 'youtube': '독서영상', 'meeting': '작가만남', 'userbook': '나도작가다', 'dongwha': '동화서당' };

export const RECOMMEND_GROUP_NUM = ['유아', '낮은학년', '가운데학년', '높은학년', '청소년'];
export const READING_TEST_TYPE = new Map()
    .set('TEST1', '기본')
    .set('TEST2', '심화')
    .set('TEST3', '종합');

export const NOTICE_TYPES = { 'NOTICE_TOP': '공지', 'NOTICE': '공지', 'EVENT_RESULT': '수상', 'EVENT': '독서행사', 'EVENT_PUB': '문학행사' };
export const QNA_TYPES = { 'GENERAL': '일반', 'ERROR': '오류', 'REQUEST_FUNCTION': '일반', 'REQUEST_BOOK': '도서신청', 'TEACHER': '학교추천도서' };
export const BADGE_TYPES = { 'login': '로그인', 'following': '팔로잉', 'follower': '팔로워', 'like': '좋아요', 'like_give': '받은 좋아요', 'comment': '댓글', 'debate': '토론', 'quiz': '퀴즈', 'report': '독서 감상문', 'report_best': '우수 독서 감상문', 'picture': '독서화', 'picture_best': '우수 독서화', 'photo': '독서사진', 'photo_best': '우수 독서사진', 'video': '독서영상', 'video_best': '우수 독서영상', 'meeting': '작가와의 만남', 'meeting_king': '작가와의 만남 질문왕', 'reading': '독서활동', 'apple': '독서사과', 'rank': '독서등급', 'etc': '기타' };

export const NOTIFICATION_SERVICE = { 'SYSTEM': '독서길라잡이', 'DEBATE': '토론', 'REPORT': '독서감상문', 'PICTURE': '독서화', 'PHOTO': '독서사진', 'VIDEO': '독서영상', 'QNA': '문의', 'MEETING': '작가님이랑나랑', 'USER_BOOK': '나도작가다', 'USER_BOOK_EPISODE': '나도작가다', 'CUSTOM': '독서길라잡이', 'DONGWHA': '동화서당', 'WARNING': '주의' }
export const NOTIFICATION_TYPE = { 'KEEP': '찜하기', 'LIKE': '좋아요', 'COMMENT': '댓글', 'FOLLOW': '팔로우', 'APPLE': '독서사과', 'BADGE': '뱃지', 'SYSTEM': '독서갈라잡이', 'DIRECT': '독서갈라잡이', 'ETC': '독서갈라잡이' };
export const VIDEO_STATE = { 'waiting': '대기', 'active': '활성', 'reject': '거절', 'delete_request': '삭제요청중', 'delete': '삭제완료' };

export const CANVAS_CORNER_OPTION = {
    cornerColor: '#5f99f6',
    cornerSize: 8
};

export const USER_TYPE_LIST = {
    student: '학생',
    teacher: '선생님',
    parent: '부모님',
    system_user: '독서길라잡이',
    system_admin: '독서길라잡이',
    author: '훈장님',
};

export const APPLE_RANK_NAMES = ['입문자', '초보', '중수', '고수', '마스터', '그랜드 마스터', '독서의 신'];
export const READING_RANK = [
    { rank: 7, startNum: 635, name: '독서의 신', steps: [] },
    { rank: 6, startNum: 460, name: '독서 그랜드 마스터', steps: [25, 25, 25, 25, 25, 25, 25] },
    { rank: 5, startNum: 315, name: '독서 마스터', steps: [15, 15, 20, 20, 25, 25, 25] },
    { rank: 4, startNum: 185, name: '독서 고수', steps: [10, 15, 15, 20, 20, 25, 25] },
    { rank: 3, startNum: 80, name: '독서 중수', steps: [10, 15, 15, 20, 20, 25] },
    { rank: 2, startNum: 10, name: '독서 초보', steps: [10, 10, 15, 15, 20] },
    { rank: 1, startNum: 0, name: '독서 입문자', steps: [5, 5] }
]


